import { Button, Modal, Space, Dropdown, Typography } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import DataTable from "../components/Tables/Datatable";
import { actionMenuItems, items } from "../constant";
import SearchInput from "../components/Forms/SearchInput";
import { TbDotsVertical } from "react-icons/tb";
import { useApiCall } from "../services/api";
import Access from "../components/models/Access";
import Delete from "../components/models/Delete";
import { useSelector } from "react-redux";
import { useNavigate, useOutletContext, useSearchParams } from "react-router-dom";
import Loader from "../common/Loader";
import { useGlobalModal } from "../context/SuccessModalProvider";
import Filters from "../components/Filters";
import { handleRouteNav } from "../utils";
import usePagination from "../hooks/usePagination";
import ManageAgents from "../components/models/ManageAgents";

const Sales = () => {
  const { appliedFilters, ModalUI, FilterButton } = Filters({
    filters: [
      {
        type: "select",
        key: "noOfClients",
        label: "Assigned Clients",
        inputProps: {
          placeholder: "Select Clients Count",
        },
        options: [
          { label: "0", value: "0" },
          { label: "1 - 4", value: "1-4" },
          { label: "5 - 10", value: "5-10" },
          { label: "> 10", value: "10+" },
        ],
      },
    ],
    onChange: () => resetPage(),
  });

  const { postApi, loading } = useApiCall();
  const { showPopup } = useGlobalModal();
  const [tableLoading, setTableLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totalSales, setTotalSales] = useState(0);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const { pagination, setPagination, handleChange: handlePaginationChange, resetPage } = usePagination();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isDeleteModal, setIsDeleteModel] = useState(false);
  const [accessType, setAccessType] = useState(null);
  const [dropDownList, setDropDownList] = useState([]);
  const [accessList, SetAccessList] = useState([]);
  const { user_id, full_name, role_id, is_sales_person } = useSelector((state) => state.auth);
  const { listRefreshKey } = useSelector((state) => state.cartRefresh);

  const [customers, setCustomers] = useState([]);
  const [newCustomers, setNewCustomers] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [recordDetails, setRecordDetails] = useState({});
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();
  const query = searchParams.get("q") || "";
  const fetchIdRef = useRef(0);

  const handleChange = (paginationInfo, filters, sorter) => {
    handlePaginationChange(paginationInfo, filters, sorter);
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const handleRow = (record) => {
    if (record.user_id !== user_id) {
      navigate(handleRouteNav("/sales-profile", role_id), {
        state: { user_id: record.user_id, routeType: "sales" },
      });
    }
  };

  const showModal = (type, id, record) => {
    setRecordDetails(record);
    setDeleteId(id);
    if (type == "Edit Access") {
      if (record?.customers.length == 0) {
        return showPopup({
          title: null,
          content: <span className="custom-modal-title">No clients found for the given salesperson.</span>,
          onOk: () => console.log("Confirmed!"),
          className: "custom-success-modal",
        });
      }
      setAccessType(type);
      setIsModalVisible(true);
    } else if (type == "delete") {
      setIsDeleteModel(true);
    } else if (type == "Assign Client") {
      setAccessType(type);
      setIsModalVisible(true);
    } else if (type == "manage_agents") {
      if (record?.customers.length == 0) {
        return showPopup({
          title: null,
          content: <span className="custom-modal-title">No clients found for the given salesperson.</span>,
          onOk: () => console.log("Confirmed!"),
          className: "custom-success-modal",
        });
      }
      setAccessType(type);
      setIsModalVisible(true);
    }
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "user_id",
      key: "user_id",
      ellipsis: true,
      width: 100,
    },
    {
      title: "Salesperson",
      dataIndex: "full_name",
      key: "full_name",
      ellipsis: true,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      ellipsis: true,
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      ellipsis: true,
    },
    {
      title: "Assigned Clients",
      key: "assignedClients",
      render: (record) => {
        const customerList = record.customers || [];

        return `${customerList.length ? customerList.map((item) => item.company_name).join(", ") : "-"}`;
      },
      ellipsis: true,
    },
    {
      title: "Clients Count",
      key: "customers_count",
      dataIndex: "customers_count",
      ellipsis: true,
    },
    !is_sales_person && {
      title: "",
      key: "action",
      fixed: "right",
      width: 60,
      render: (record) => (
        <Dropdown
          menu={{
            items: actionMenuItems,
            onClick: ({ key, domEvent }) => {
              domEvent.stopPropagation();
              if (key == 2) {
                showModal("Edit Access", record.user_id, record);
              } else if (key == 3) {
                if (record?.customers.length > 0) {
                  return showPopup({
                    title: null,
                    content: (
                      <span className="custom-modal-title">
                        You cannot delete a sales employee with assigned clients. Please remove clients first.
                      </span>
                    ),
                    onOk: () => console.log("Confirmed!"),
                    className: "custom-success-modal",
                  });
                }
                showModal("delete", record.user_id, record);
              } else if (key == 1) {
                showModal("Assign Client", record.user_id, record);
              } else if (key == 4) {
                showModal("manage_agents", record.user_id, record);
              }
            },
          }}
          trigger={["click"]}
          overlayClassName="custom-dropdown-sales-menu"
        >
          <Typography.Link
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <Space>
              <TbDotsVertical className="text-red-700" size={18} />
            </Space>
          </Typography.Link>
        </Dropdown>
      ),
    },
  ].filter(Boolean);

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleDeleteOk = async () => {
    const res = await postApi("user/delete", { user_id: deleteId, updated_by_id: user_id, updated_by: full_name }, true);
    if (res && res?.status) {
      setIsDeleteModel(false);
      fetchSales();
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setIsDeleteModel(false);
  };

  const onSearch = (value, _e, info) => console.log(info === null || info === void 0 ? void 0 : info.source, value);

  const handleMenuClick = (e) => {
    console.log("click", e);
  };

  const fetchSales = useCallback(async () => {
    fetchIdRef.current += 1;
    const currentFetchId = fetchIdRef.current;
    try {
      setTableLoading(true);
      const { noOfClients } = appliedFilters;

      const filters = {
        client_range: noOfClients,
      };

      const body = {
        per_page: pagination.pageSize,
        page: pagination.current,
        search: query,
        ...(Object.keys(appliedFilters).length ? filters : {}),
      };
      const res = await postApi("sales/sales-person-list", body);
      if (currentFetchId !== fetchIdRef.current) {
        return;
      }
      if (res && res.data) {
        setData(res.data);
        setTotalSales(res.total);
      } else {
        setData([]);
        setTotalSales(0);
      }
    } catch (error) {
      if (currentFetchId !== fetchIdRef.current) {
        return;
      }
      console.error("Error fetching sales:", error);
    } finally {
      if (currentFetchId !== fetchIdRef.current) {
        return;
      }
      setTableLoading(false);
    }
  }, [appliedFilters, pagination.current, pagination.pageSize, query]);

  const fetchDropDownList = async () => {
    const res = await postApi("sales/assign-customer-list");
    if (res && res.data) {
      let isFilter = res.data.filter((item) => item.is_agent == 0);
      let isAccess = res.data.filter((item) => item.user_id == deleteId);
      SetAccessList(isAccess);
      setDropDownList(isFilter);
    }
  };

  const handleOnSearchChange = (e) => {
    const value = e.target.value;
    setSearchParams(
      (prev) => {
        if (value) prev.set("q", value);
        else prev.delete("q");
        return prev;
      },
      { replace: true },
    );
    resetPage();
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchSales();
    }, 300);

    return () => clearTimeout(handler);
  }, [fetchSales, listRefreshKey]);

  useEffect(() => {
    if (isModalVisible && (accessType === "Assign Client" || accessType === "Edit Access")) {
      fetchDropDownList();
    }
  }, [isModalVisible]);

  const handleSubmit = async () => {
    let assignData = {
      customer_id: newCustomers,
      user_id: deleteId,
      updated_by: full_name,
      updated_by_id: user_id,
    };
    let response;
    if (accessType == "Assign Client") {
      assignData = { ...assignData, remove_access_id: newCustomers };
      response = await postApi("sales/assign-sales-person", assignData, true);
    } else if (accessType == "Edit Access") {
      response = await postApi("sales/edit-allow-multiple", assignData, true);
    }
    if (response?.data || response?.status) {
      handleCancel();
      fetchSales();
    }
  };

  const { setTitle, setDescription, setBackButton } = useOutletContext();

  useEffect(() => {
    setTitle("Salesperson List");
    setDescription(`${totalSales} total sales employees`);
    setBackButton(false);
  }, [setTitle, setDescription, setBackButton, totalSales]);

  return (
    <>
      <ModalUI />
      <>
        <div className="bg-[#FFFFFF]" style={{ borderRadius: "32px", overflow: "hidden" }}>
          <div className="flex flex-row justify-between items-center gap-3 w-full px-8 py-6">
            {/* Search Input */}
            <SearchInput onSearch={onSearch} placeholder="Search for a salesperson" value={query} onChange={handleOnSearchChange} />

            <div className="flex items-center gap-3">
              <FilterButton />

              {/* Employees Button */}
              <Button
                type="primary"
                className="h-[45px] bg-[#7070701A] hover:!bg-[#7070701A] hover:!text-[#A33434] font-bold text-[#A33434] text-sm sm:text-base whitespace-nowrap !cursor-default"
                size="middle"
              >
                {totalSales} sales employees
              </Button>
            </div>
          </div>
          {tableLoading ? (
            <div className="flex justify-center items-center py-20">
              <Loader size={60} />{" "}
            </div>
          ) : (
            <DataTable
              columns={columns}
              data={data}
              handleChange={handleChange}
              handleRow={handleRow}
              pagination={{
                current: pagination.current,
                pageSize: pagination.pageSize,
                total: totalSales,
                showSizeChanger: true,
              }}
            />
          )}
        </div>
      </>
      <Modal
        className="form-css-2"
        open={isModalVisible && (accessType === "Assign Client" || accessType === "Edit Access")}
        onOk={handleOk}
        footer={null}
        onCancel={handleCancel}
      >
        <Access
          plainOptions={accessType === "Assign Client" ? dropDownList : accessList}
          data={recordDetails}
          setCustomers={setCustomers}
          setNewCustomers={setNewCustomers}
          customers={customers}
          handleSubmit={handleSubmit}
          closeModal={() => setIsModalVisible(false)}
          text={accessType}
          loading={loading}
        />
      </Modal>
      <Modal className="form-css-4" open={isDeleteModal} footer={null} onCancel={handleCancel}>
        <Delete
          text=""
          handleSubmit={handleDeleteOk}
          closeModal={() => setIsDeleteModel(false)}
          pageName="Salesperson"
          recordName={recordDetails?.full_name}
          loading={loading}
        />
      </Modal>

      <ManageAgents data={recordDetails} open={isModalVisible && accessType === "manage_agents"} onClose={() => setIsModalVisible(false)} />
    </>
  );
};

export default Sales;
